module.exports = __webpack_public_path__ + "img/005.02a3515f.jpg";